import React from 'react';
import { shiftSummaryDashboardCompleted } from "./FatigueAssessmentPageSelector";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import FatigueAssessmentDashboard from "./FatigueAssessmentDashboard";

const FatigueAssessmentDashboardCompleted = () => {
    return (
        <FatigueAssessmentDashboard
            page={shiftSummaryDashboardCompleted}
            pageView={FatigueAssessmentView.Completed}
        />
    );
}

export default FatigueAssessmentDashboardCompleted;
